<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<h2 class="heading-2 mt-4" [attr.id]="rolesHeadingId">Rollen für OZG-Cloud<i aria-hidden="true">*</i></h2>
<fieldset role="radiogroup" aria-required="true" [attr.aria-labelledby]="rolesHeadingId" [attr.aria-invalid]="!isValid">
  <div class="flex flex-col gap-4 md:flex-row" [attr.aria-describedby]="validationErrorId">
    <div class="flex flex-1 flex-col gap-2">
      <h3 class="text-md text-text block font-medium">Administration</h3>
      @for (role of adminRoles; track role) {
        <administration-role-checkbox [role]="role" />
      }
    </div>
    <div class="flex flex-1 flex-col gap-2">
      <h3 class="text-md text-text block font-medium">Alfa</h3>
      @for (role of alfaRoles; track role) {
        <administration-role-checkbox [role]="role" [isAlfaRole]="true" />
      }
    </div>
  </div>
  <odc-validation-error
    [id]="validationErrorId"
    [invalidParams]="invalidParams$ | async"
    label="Rollen"
    data-test-id="rollen-error"
  ></odc-validation-error>
</fieldset>
